export default "__VITE_ASSET__BDGvPe9d__"